import toast from "react-hot-toast";
import axiosInstance from "./axiosInstance";

const subscriptionService = {
  getAll: async () => {
    try {
      const response = await axiosInstance.get("/subscription/all");
      console.log("Response from login API:", response);
      return response.data;
    } catch (error) {
      throw error?.response?.data || error;
    }
  },
  getAllPurchasedSubscriptions: async (params = {}) => {
    try {
      const queryParams = new URLSearchParams();
      if (params.page) queryParams.append("page", params.page);
      if (params.limit) queryParams.append("limit", params.limit);
      if (params.duration) queryParams.append("duration", params.duration);
      if (params.emailType) queryParams.append("emailType", params.emailType);

      const queryString = queryParams.toString();
      const url = `/subscription/all-purchased${
        queryString ? `?${queryString}` : ""
      }`;
      const response = await axiosInstance.get(url);
      return response.data;
    } catch (error) {
      throw error?.response?.data || error;
    }
  },
};

export default subscriptionService;
